/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';
import Slider from 'react-slick';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken } from '../utils/util';
import './Room.css';
import Wrapper from './Wrapper';
import ReviewItem, { PercentBar } from './partials/ReviewItem';
import QuickEscapeAdder from './partials/QuickEscapeAdder';
import EscapeAdder from './partials/EscapeAdder';
import Badge from './partials/Badge';
import Sharing from './partials/Sharing';
import { SITE_DOMAIN } from '../config';

import {
  fetchUser,
  getRoom,
  listRooms,
  listTimeSlots,
  listThreads,
  addComment,
} from '../actions';


class Gallery extends Component {

  state = { big: null };

  close(e) {
    e.stopPropagation();
    this.setState({ big: null });
  }

  showBig(idx) {
    this.setState({ big: idx });
  }

  renderBig() {
    if (this.state.big == null) return null;

    let room = this.props.room;
    // let nodes = this.renderNodes();
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: this.state.big,
    };

    let nodes = room.images.map(image => {
      return (
        <div key={image.id} className="image">
          <img src={image.url} />
        </div>
      );
    });

    return (
      <div className="big-gallery">
        <Slider {...settings}>
          {nodes}
        </Slider>
        <div className="close-gallery">
          <div className="close-button" onClick={(e) => this.close(e)}>Close</div>
        </div>
      </div>
    );
  }

  renderNodes() {
    let room = this.props.room;

    let i = 0;
    return room.images.map(image => {
      let idx = i++;
      return (
        <div key={image.id} className="image">
          <img onClick={() => this.showBig(idx)} src={image.url} />
        </div>
      );
    });
  }

  render() {
    let room = this.props.room;
    if (!room || !room.images || room.images.length == 0) {
      return null;
    }

    let nodes = this.renderNodes();

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      autoplay: true,
    };

    return (
      <div className="gallery-wrapper">
        {this.renderBig()}

        <div className="gallery">
          <Slider {...settings}>
            {nodes}
          </Slider>
        </div>
      </div>
    );
  }
}


class TimeSlot extends Component {
  render() {
    let timeSlot = this.props.timeSlot;
    return (
      <div className={cx('TimeSlot', timeSlot.status)}>
        <a href={timeSlot.bookUrl}>
          <div className="time">{timeSlot.prettyHour}</div>
          <div className="status">{timeSlot.status}</div>
        </a>
      </div>
    );
  }
}

class TimeSlots extends OzComponent {
  render() {
    let timeSlots = this.props.timeSlots;
    let m = this.props.moment;
    let prettyDate;
    if (m.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
      prettyDate = 'Today';
    } else {
      prettyDate = m.format('dddd, MMM Do');
    }
    let nodes = timeSlots.map(timeSlot => <TimeSlot key={timeSlot.id} timeSlot={timeSlot} />);
    return (
      <div className="time-slots-wrapper">
        <div className="date">{prettyDate}</div>
        <div className="time-slots">{nodes}</div>
      </div>
    );
  }
}


class Thread extends OzComponent {
  state = {};

  didRoom() {
    let room = this.props.room;
    let user = this.props.user;
    if (!user || !room) return false;
    let profile = user.profile;
    if (!profile) return false;

    console.log('check did escape:', room, profile);

    for (let escape of profile.escapes) {
      if (escape.room.id == room.id) {
        console.log('returning YES!');
        return true;
      }
    }
    return false;
  }

  addedEscape() {
    console.log('ADDED!');
    this.props.onAddedEscape();
    this.props.fetchUser();
    this.props.listThreads({ room: this.props.room.id }, { background: true, silent: true });
  }

  addComment() {
    this.setState({ loading: true });
    this.props.addComment({
      roomId: this.props.room.id,
      body: this.state.body,
    }, { silent: true })
      .then(resp => this.props.listThreads({ room: this.props.room.id }, { background: true, silent: true }))
      .then(resp => {
        this.setState({
          loading: false,
          didLoad: true,
          body: '',
        });
      });
  }

  renderAddComment() {
    let user = this.props.user;

    return (
      <div className="add-comment">
        <div className="prompt">Add a comment.</div>
        <div className="spoilers-ok"><b>Spoilers are ok</b>, discussion only visible to those who have done this room.</div>

        <div className="posting-as">
          <Badge profile={user.profile} />
        </div>

        <FormControl
          componentClass="textarea"
          value={this.state.body}
          onChange={ss(this, 'body')}
        />

        {!this.state.loading && <Button bsStyle="primary" onClick={() => this.addComment()}>Add Comment</Button>}
        {this.state.loading && <div>Adding comment...</div>}
      </div>
    )
  }

  renderComments() {
    let thread = this.props.thread;
    if (!thread) {
      return;
    }

    let nodes = thread.comments.map(comment => {
      return (
        <div key={comment.id} className="comment">
          <Badge profile={comment.profile} />
          <div className="body">
            <div className="time-ago">{moment(comment.timeCreated).fromNow()}</div>
            <div>{comment.body}</div>
          </div>
          <hr/>
        </div>
      )
    });

    return (
      <div className="thread-comments">
        {nodes}
      </div>
    )
  }

  render() {
    let room = this.props.room;
    let user = this.props.user;
    if (!room || !user) return null;

    if (!user.profile) {
      return (
        <div className="thread-hidden">Sign in to discuss this room</div>
      );
    }

    let didRoom = this.didRoom();
    if (!didRoom) {
      return (
        <div className="thread-hidden">
          <div className="header-wrapper">
            <div className="header">Discuss</div>
          </div>
          <p>Discussion thread is available to people who have done this room.</p>

          <QuickEscapeAdder
            room={room}
            user={this.props.user}
            size="lg"
            onDone={() => this.addedEscape()}
          />

          {/*<EscapeAdder
            room={this.props.room}
            user={this.props.user}
            onDone={() => this.addedEscape()}
            addingEscape={this.state.addingEscape}
            showProfileLink={true}
            >
            <Button bsStyle="primary">
              Add Escape & Discuss
            </Button>
          </EscapeAdder>*/}
        </div>
      );
    }

    return (
      <div className="Thread">
        <div className="header-wrapper">
          <div className="header">
            Discussion
          </div>
        </div>

        {this.renderComments()}
        {this.renderAddComment()}
      </div>
    )
  }
}


class Room extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['room', getRoom, p => p.id],
    ['companyRooms', listRooms, p => { return [{ sameLocation: p.id }, { targetKey: 'companyRooms' }] }],
    ['timeSlots', listTimeSlots, p => { return { room: p.id} }],
    ['threads', listThreads, p => { return { room: p.id} }],
  ];

  state = {};

  addedEscape() {
    this.setState({ addingEscape: false });
  }

  renderAward() {
    let room = this.props.room;
    if (!room || !room.topRoomImgTeal) return;
    return (
      <div className="top-room">

        <img src={room.topRoomImgTeal} />
      </div>
    );
  }

  renderRoom() {
    let room = this.props.room;
    if (!room) return;
    let timeSlots = (this.props.timeSlots && this.props.timeSlots.items) ? this.props.timeSlots.items : [];

    let timeSlotsByDate = {};
    for (let timeSlot of timeSlots) {
      let m = moment(timeSlot.datetime);
      let date = m.format('YYYY-MM-DD');
      if (!timeSlotsByDate[date]) {
        timeSlotsByDate[date] = { moment: m, timeSlots: [] };
      }
      timeSlotsByDate[date].timeSlots.push(timeSlot);
    }

    let dates = Object.keys(timeSlotsByDate);
    dates.sort();
    let nodes = [];
    for (let date of dates) {
      let m = timeSlotsByDate[date].moment;
      let timeSlots = timeSlotsByDate[date].timeSlots;
      let node = <TimeSlots moment={m} timeSlots={timeSlots} />;
      nodes.push(node);
    }
    let more;
    if (nodes.length) {
      more = 'More';
    } else {
      more = '';
    }

    let url;
    if (room.location) {
      url = '/s?city=' + encodeURIComponent(room.location.city.fullName) + '&room=' + room.name;
    } else {
      url = '/s';
    }

    let thread;
    let threads = this.props.threads;
    if (threads && threads.items.length) {
      thread = threads.items[0];
    }

    let threadNode = (
      <Thread
        room={this.props.room}
        user={this.props.user}
        thread={thread}
        addComment={this.props.addComment}
        fetchUser={this.props.fetchUser}
        listThreads={this.props.listThreads}
        onAddedEscape={() => this.addedEscape()}
      />
    );

    let galleryNode = (
      <Gallery room={this.props.room} />
    );

    let shareUrl = SITE_DOMAIN + '/r/' + room.slug + '/' + room.id;

    return (
      <div className="room">
        <div className="room-info">
          {room.location && <div className="address">{room.location.address}</div>}
          <div className="num-players">
            {!!(room.minPeople && room.maxPeople) && <span>{room.minPeople}-{room.maxPeople} players</span>}</div>
          <div>{!!room.minutes && <span>Duration: {room.minutes} minutes</span>}</div>
          {room.difficulty && <div>Difficulty: {room.difficulty}</div>}
          <hr/>
          <div className="description">{(room.description || '').replace(/\n+/, '\n')}</div>

          <br/>
          {room.url && <span><a href={room.url} rel="nofollow" className="btn btn-default" target="_blank">Visit Room Website</a>{' '}</span>}
          <Link to={url}><Button>See Available Times</Button></Link>

          <br/>

          <div className="phone-thread">{threadNode}</div>

          {this.renderReviews()}
          {this.renderEscapes()}
        </div>
        <div className="room-times">
          {this.renderAward()}
          <div className="desktop-gallery">{galleryNode}</div>
          <div className="desktop-thread">{threadNode}</div>
          <div>{nodes}</div>
          <div className="buttons">
          </div>
        </div>
      </div>
    );
  }

  renderEscapes() {
    let room = this.props.room;
    if (!room) return;

    let seen = {};
    let didIt = false;
    let nodes = room.escapes.map(escape => {
      if (seen['e' + escape.id]) return null;
      if (escape.team && seen['t' + escape.team.id]) return null;
      if (escape.username && seen['u' + escape.username]) return null;

      seen['e' + escape.id] = true;
      if (escape.team) seen['t' + escape.team.id] = true;
      seen['u' + escape.username] = true;

      if (this.props.user && escape.username == this.props.user.username) {
        didIt = true;
      }

      let body = (
        <div className="escape">
          <div className="who">
            {escape.team && escape.team.name}
            {!escape.team && escape.username}
          </div>
          
          <div className="escape-outcome">
            {escape.didEscape && <div className="outcome yes">ESCAPED!</div>}
            {!escape.didEscape && <div className="outcome nope">Nope...</div>}
            <div className="escape-time">
              {escape.didEscape && escape.time && <div className="your-time">{escape.time}min</div>}
            </div>
          </div>
        </div>
      );
      let to;
      if (escape.team) {
        to = '/team/' + escape.team.id;
      } else {
        to = '/p/' + escape.username;
      }
      return <Link key={escape.id} to={to}>{body}</Link>;
    });

    return (
      <div className="section">
        <div className="header-wrapper">
          <div className="header">
            Escapes
          </div>
        </div>

        {nodes.length == 0 && (
          <div>
          No escapes yet... create a profile and record your escape!
          </div>
         )}
        {nodes.length > 0 && <div className="escapes">{nodes}</div>}

          {!didIt && <EscapeAdder
            room={this.props.room}
            user={this.props.user}
            onChange={() => this.setState({ addingEscape: false })}
            addingEscape={this.state.addingEscape}
            showProfileLink={true}
            >
            <Button bsStyle="primary">
              Record my ESCAPE
            </Button>
          </EscapeAdder>}

      </div>
    );
  }

  renderReviews() {
    let room = this.props.room;
    if (!room) return;
    let user = this.props.user;
    let profile = null;
    if (user) profile = user.profile;

    let reviewedIt = false;
    let nodes = room.reviews.map(review => {
      if (profile && profile.username == review.username) {
        reviewedIt = true;
      }
      return <ReviewItem review={review} />
    });
    return (
      <div className="section">
        <div className="header-wrapper">
          <div className="header">
            Reviews
          </div>
        </div>

        {nodes.length == 0 && <div>No reviews yet... create a profile and add one!</div>}
        {nodes.length > 0 && <div className="reviews">{nodes}</div>}
          {profile && !reviewedIt && <EscapeAdder
            room={this.props.room}
            user={this.props.user}
            onChange={() => this.setState({ reviewing: false })}
            addingEscape={this.state.reviewing}
           showProfileLink={true}
           skipToReview={true}
            >
            <Button bsStyle="primary">
              Review this Room
            </Button>
          </EscapeAdder>}

      </div>
    );
  }

  renderCompanyRooms() {
    let companyRooms = this.props.companyRooms;
    let room = this.props.room;
    if (!companyRooms || !room || !room.location) return;

    let nodes = [];
    for (let r of companyRooms.items) {
      if (r.id == room.id) continue;
      let url = '/r/' + r.slug + '/' + r.id;
      let node = (
          <div className="company-room">
            <a href={url}>
              <div className="company-room-name">{r.name}</div>
              {r.percent && <PercentBar percent={r.percent} />}
            </a>
        </div>
      );
      nodes.push(node);
    }

    if (nodes.length == 0) {
      return null;
    }

    return (
      <div className="section">
        <div className="header-wrapper">
          <div className="header">
            Other Rooms by {room.location.company}
          </div>
        </div>
        <div className="company-rooms">
          {nodes}
        </div>
      </div>
    );
  }

  render() {
    let room = this.props.room || {};
    return (
      <Wrapper className="Room">
        <Helmet>
          <title>{room.name ? room.name : ''} time slots and reviews - EscapeSpy</title>
        </Helmet>

        <div className="room-header">
          <div className="room-name">{room.name}</div>
          <div className="company-name">{room.location && room.location.company}</div>
        </div>
        {this.renderRoom()}
        {this.renderCompanyRooms()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    room: state.get.room,
    companyRooms: state.list.companyRooms,
    timeSlots: state.list.timeSlot,
    threads: state.list.thread,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    fetchUser,
    addComment,
    listThreads,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Room);



/** WEBPACK FOOTER **
 ** ./src/components/Room.js
 **/